import { CommonModule } from '@angular/common';
import { Component, Input, Output } from '@angular/core';
import { EventEmitter } from '@angular/core';

@Component({
    selector: 'app-policy',
    imports: [CommonModule],
    templateUrl: './policy.component.html',
    styleUrl: './policy.component.less'
})
export class PolicyComponent {

  @Input() showPolicy: boolean = false;
  @Output() closePolicyEvent: EventEmitter<void> = new EventEmitter<void>();

  closePolicy() {
    this.closePolicyEvent.emit();
  }

}
